var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import { PageConnector, PageEditProvider, PageDragDrop, Scroll, MetaTags, PageUpgrade } from '../';
import { BlocksConnector, SettingsConnector, AdminSidebar, ADMIN_ROUTE, Admin } from '../../';
import { useLocation, useRouteMatch, Route } from 'react-router-dom';
export var Page = memo(function (_a) {
    var children = _a.children, metaProps = __rest(_a, ["children"]);
    var location = useLocation();
    var isAdminPage = useRouteMatch(ADMIN_ROUTE);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageConnector, { pathname: location.pathname }),
        React.createElement(BlocksConnector, null),
        React.createElement(SettingsConnector, null),
        React.createElement(PageEditProvider, null,
            React.createElement(MetaTags, __assign({}, metaProps)),
            !isAdminPage && React.createElement(PageUpgrade, null),
            React.createElement(PageDragDrop, null,
                React.createElement(AdminSidebar, null),
                React.createElement(Scroll, null,
                    React.createElement(Route, { path: ADMIN_ROUTE },
                        React.createElement(Admin, null)),
                    React.createElement(Route, null, children))))));
});
